import {AttachmentType} from 'Interfaces'
import {orderBy} from 'lodash'

export const sort = (items: AttachmentType[]): AttachmentType[] =>
  orderBy(
    items,
    [(o) => o.type === 'CV', (o) => o.dateUpdated],
    ['desc', 'desc']
  )
